/** Meta pixel "pixel martial arts kids class ready" (stockdigital.com, for the stock 4 ad account).
 *  PageView on load, ViewContent when the offer section is seen, InitiateCheckout ONLY on the offer button. */
export const META_PIXEL_ID = '1694960845480040';
